import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { isNil, isEmpty, has } from 'lodash';
import { BehaviorSubject, Observable, of } from 'rxjs';
import * as dayjs from 'dayjs';
import { catchError, first, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class AppUtilsService {
  public status: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public subscribeOrders: BehaviorSubject<boolean> = new BehaviorSubject<any>(null);
  public loaderImage: BehaviorSubject<string> = new BehaviorSubject<string>("assets/img/cdlogo.gif");
  public browserTabName: BehaviorSubject<string> = new BehaviorSubject<string>("ChefDesk");
  private loginPopupSubject = new BehaviorSubject<boolean>(false);
  loginPopup$ = this.loginPopupSubject.asObservable();

  orders;
  selectedTenant;
  loginUser = 'My Account';
  rootObject;

  fronCart = false;
  hideHeader = false;
  mapAddress = false;
  fixedLocation = '';
  finalOrderData;
  logo;

  totalAmount = 0;
  gstAmount = 0;
  subtotal = 0;

  menuLogin = false;

  constructor(private http: HttpClient) { }


  get_yyyy_MM_dd_Format(date: string): string {
    return date
      .split('-')
      .reverse()
      .join('-');
  }

  checkImagePath(imagePath: string): Observable<boolean> {
    return this.http.head(imagePath, { observe: 'response' })
      .pipe(
        map((response: any) => response.status === 200 && response.body.byteLength > 0),
        catchError(() => of(false))
      );

  }
  checkImageExistence(imagePath: any) {
    return fetch(imagePath, { method: 'HEAD' })
      .then((response: any) => {
        console.log(response.ok + "||" + response.status);
        return response.ok || response.status === 404;
      })
      .catch(() => false);
  }

  // alertType -- success or fail or content
  // alertMessage -- success or fail message
  getAlert(alertType: string, alertmessage: string) {
    console.log('get alert : ' + alertType);
    return Swal.fire(
      alertType + alertmessage
    );
  }

  ShowItemsNotAvailableAlert(alertType: string, alertmessage: string) {
    Swal.fire({
      text: alertType + alertmessage,
      customClass: {
        container: 'my-swal'
      }
    });
  }

  getHtmlAlert(alertType: string, html: string, alertmessage: string) {
    console.log('get alert : ' + alertType);
    return Swal.fire(
      '', `<html>
    < body >
    <p style="font-size: 10px;">`+ alertType + alertmessage + `< /p>
    < /body>
  < /html>`
      ,
      'error'
    );
  }

  showSuccessAlert(alertmessage: string) {
    return Swal.fire(
      alertmessage,
      '',
      'success'
    );
  }
  showInfoAlert(alertmessage: string) {
    return Swal.fire(
      alertmessage,
      '',
      'info'
    );
  }
  keyExists(data: any, keyName: string) {
    return has(data, keyName);
  }
  isNullOrEmpty(data: any) {
    return isNil(data) || isEmpty(data);
  }
  validHttpResponse(response: any) {
    if (isNil(response) || isEmpty(response)) {
      return false;
    }
    if (has(response, 'status') && response.status === 'success') {
      return true;
    }
    return false;
  }
  showError(errorObj) {
    if (errorObj.status && errorObj.status === 401) {
      return;
    }
    if (errorObj.error && errorObj.error.type && errorObj.error.error) {
      if (errorObj.error.type === 'AppError') {
        return Swal.fire('Service is down, Please try again after sometime', '', 'error');
      }
      if (errorObj.error.type === 'UserError') {
        return Swal.fire(errorObj.error.error, '', 'error');
      }
    } else {
      return Swal.fire('Service is down, Please try again later', '', 'error');
    }
  }
  // getReportUrl(params) {
  //   //let url = 'reportName=' + name
  //   let url = `tenant_id=${environment.tenant_id}`

  //   if (params.reportName == 'TourPassengerChart') {
  //     url += '&P_Journey_Date=' + params.P_From_Date
  //   }


  //   let keys = Object.keys(params)
  //   let b = false
  //   keys.forEach(key => {
  //     if (b) {
  //       b = false
  //       url += key + '=' + params[key]
  //     }
  //     else {
  //       url += '&' + key + '=' + params[key]
  //     }
  //   });
  //   console.log('url = ' + url);
  //   return url
  // }



  loginRlogout(value: boolean) {
    this.status.next(value);
  }

  logined() {
    if (localStorage.getItem('ccId')) {
      this.status.next(true);
    } else {
      this.status.next(false);
    }

  }

  logouted() {
    this.status.next(false);
  }

  updateOrder(orderArray) {
    this.subscribeOrders.next(orderArray);

  }

  updateLoaderImage(img: string) {
    img = img ? img : "default";
    localStorage.setItem("loaderImage", "assets/img/" + img + ".gif");
    this.loaderImage.next("assets/img/" + img + ".gif");
  }

  updateBrowserTabName(tabName: string) {
    tabName = tabName ? tabName : "ChefDesk";
    localStorage.setItem("tabName", tabName)
    console.log("applogo:::" + this.logo);
    localStorage.setItem("applogo", this.logo ? this.logo : "assets/img/favicon-32x32.png");
    this.browserTabName.next(tabName);
  }

  getUser() {
    if (localStorage.getItem('ccId')) {
      return true;
    } else {
      return false;
    }
  }



  orderItemCountChange(ordersArray) {
    this.totalAmount = 0;
    this.gstAmount = 0;
    this.subtotal = 0;
    let taxableAmount = 0;

    ordersArray.forEach(order => {
      let tax = 0;
      this.totalAmount += (order.itemCount * order.itemPrice);
      // console.log('itemName::::' + order.itemName + '   tax_inclusive:::: ' + order.tax_inclusive);

      if (!order.tax_inclusive) {
        order.tax.forEach(taxobj => {
          tax += taxobj.tax_value;
        });
        taxableAmount = (order.itemCount * order.itemPrice);
        order.taxAmount = ((order.itemCount * order.itemPrice) * (tax / 100));
        // console.log('order.taxAmount' + order.taxAmount);
      }
      this.gstAmount += (taxableAmount * (tax / 100));
      // console.log('gstAmount:::: Before' + this.gstAmount);
    });
    this.gstAmount = parseFloat((this.gstAmount).toFixed(2));
    // console.log('gstAmount:::: After' + this.gstAmount);

    // this.subtotal = Math.round(this.totalAmount + this.gstAmount);
    this.subtotal = (this.totalAmount + this.gstAmount);



  }
  tempSaveData(cartitems: any, selectedRestaurant: any, items: any, ordersArray: any, totalAmount?: any, gstAmount?: any, subtotal?: any) {
    this.totalAmount = totalAmount ? totalAmount : this.totalAmount;
    this.gstAmount = gstAmount ? gstAmount : this.gstAmount;
    this.subtotal = subtotal ? subtotal : this.subtotal;

    localStorage.setItem('selectedRestaurant', JSON.stringify(selectedRestaurant));
    localStorage.setItem('items', JSON.stringify(items));
    localStorage.setItem('cartordersArray', JSON.stringify(cartitems));
    localStorage.setItem('ordersArray', JSON.stringify(ordersArray));
    localStorage.setItem('totalAmount', this.totalAmount + '');
    localStorage.setItem('gstAmount', this.gstAmount + '');
    localStorage.setItem('subtotal', this.subtotal + '');

    localStorage.setItem('carttotalAmount', this.totalAmount + '');
    localStorage.setItem('cartgstAmount', this.gstAmount + '');
    localStorage.setItem('cartsubtotal', this.subtotal + '');
    localStorage.setItem('cartItemsRestaurant', JSON.stringify(selectedRestaurant));
    this.updateOrder(ordersArray);
  }

  createProfileObj(profileform) {
    return {
      Email: profileform.controls.email.value,
      UserName: '+91' + profileform.controls.phone.value,
      Phone: profileform.controls.phone.value,
      Name: profileform.controls.name.value,
      RegisteredOn: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    };
  }

  calculateTax(data) {
    let tax_types = [];
    var myMap = new Map();

    let orders$ = of(data).pipe(map((order) => order.map((taxes) => {
      let taxData = {
        itemPrice: taxes.itemPrice,
        itemCount: taxes.itemCount,
        order_taxes: taxes.tax,
        tax_inclusive: taxes.tax_inclusive
      };
      return taxData;
    })));

    if (orders$) {
      let dummy$ =
        orders$.pipe(first(), map((taxes) => taxes.map((taxObj) => taxObj.order_taxes.map((tax) => {
          //  console.log("taxObj.tax_inclusive::::" + taxObj.tax_inclusive);
          let value = ((taxObj.itemPrice * taxObj.itemCount) * (tax.tax_value / 100));
          //  console.log("value::::" + value);
          if (myMap.has(tax.tax_name)) {
            myMap.set(tax.tax_name, myMap.get(tax.tax_name) + Number(value.toFixed(2)));
          } else {
            myMap.set(tax.tax_name, Number(value.toFixed(2)));
          }
          return '';
        })))).subscribe(() => {
          let tax_types_dup = [];
          for (let [key, value] of myMap) {
            tax_types_dup.push({ tax_name: key, value: Number(value).toFixed(2) });
          }
          tax_types = (tax_types_dup);

        });
    }

    //console.log("names::::" + JSON.stringify(tax_types));
    return tax_types;
  }

  getMenuLogin() {
    let login = false;
    const menuLogin = localStorage.getItem("menuLogin");
    const loginDateTime = localStorage.getItem("loginData");

    if (!menuLogin || !loginDateTime) {
      return false;
    }
    console.log("loginDateTime:::" + loginDateTime)
    const currentTime = dayjs();
    // const loginTime = dayjs("21-11-2024 17:02:06", "DD-MM-YYYY HH:mm:ss");
    const TIME_LIMIT_MINUTES = 30;
    // console.log(`Login Time: ${currentTime.isValid()}, Current Time: ${loginTime.isValid()}`);

    const timeDifferenceInMinutes = currentTime.diff(loginDateTime,  'minute', true);
    const isWithinLimit = timeDifferenceInMinutes <= TIME_LIMIT_MINUTES;

    console.log(`Login Time: ${loginDateTime}, Current Time: ${currentTime.format('DD-MM-YYYY HH:mm:ss')}`);
    console.log(`Time Difference (minutes): ${(currentTime.diff(loginDateTime, 'minute'))}`);
    console.log(`Is within ${TIME_LIMIT_MINUTES} minutes: ${isWithinLimit}`);

    return isWithinLimit;
  }

  showLoginPopup() {
    this.loginPopupSubject.next(true);
  }

  // Method to hide the login popup
  hideLoginPopup() {
    this.loginPopupSubject.next(false);
  }

}
